import React, { useState } from 'react';
import { CardBody, CardFooter } from './ui/Card';
import Button from './ui/Button';
import Modal from './ui/Modal';
import './Modal.css';

const TITLE_ID = 'confirm-modal-title';

function ConfirmModal({
    message,
    onConfirm,
    onCancel,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    confirmStyle = 'danger',
    tutorialId,
    showInput = false,
    inputPlaceholder = '',
    extraContent = null,
}) {
    const [inputValue, setInputValue] = useState('');

    // Map confirmStyle to button variant
    const getButtonVariant = () => {
        if (confirmStyle === 'danger') return 'danger';
        if (confirmStyle === 'success') return 'success';
        if (confirmStyle === 'warning') return 'warning';
        return 'primary';
    };

    const handleConfirm = () => {
        if (showInput) {
            onConfirm(inputValue);
        } else {
            onConfirm();
        }
    };

    return (
        <Modal
            onClose={onCancel}
            labelledBy={TITLE_ID}
            overlayClassName="modal-backdrop"
            className="modal-card"
        >
            <CardBody>
                <div className="modal-header">
                    <div className="modal-icon modal-icon--warning">
                        ⚠
                    </div>
                    <h3 className="modal-title" id={TITLE_ID}>Confirm Action</h3>
                </div>
                <p className="modal-message">{message}</p>
                {extraContent}
                {showInput && (
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder={inputPlaceholder}
                        className="modal-input"
                        autoFocus
                    />
                )}
            </CardBody>
            <CardFooter>
                <Button
                    variant="ghost"
                    onClick={onCancel}
                >
                    {cancelText}
                </Button>
                <Button
                    variant={getButtonVariant()}
                    onClick={handleConfirm}
                    autoFocus={!showInput}
                    data-tutorial={tutorialId}
                >
                    {confirmText}
                </Button>
            </CardFooter>
        </Modal>
    );
}

export default ConfirmModal;
